var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Navbar'),_c('v-main',{staticClass:"labs-bg"},[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('v-footer',[_c('span',{staticClass:"ml-auto overline"},[_vm._v("Cultiv.ai ©2020")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }